import axios from 'axios';
import { CreateNewMonthAPIsConstants } from "./../enums/daily-movements/CreateNewMonthEnums";
import DownloadService from '@/core/services/DownloadService';

const CreateNewMonthModule = {
    namespaced: true,
    actions: {
        addItem({ commit }, { apiPath, credentials }) {
            return new Promise((resolve, reject) => {
                axios
                .post(`${apiPath}`, credentials)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
            });
        },
    }
}
export default CreateNewMonthModule;